<template>
  <!-- Ipad and up -->
  <v-app v-if="$vuetify.breakpoint.smAndUp" class="ma-0 pa-0" style="background-color: #eee">
    <v-app-bar app  shrink-on-scroll  v-if="!isLogin" class="ma-0 pa-0">
      <v-container v-if="scrolled == false" class="ma-0 pa-0" width="100%">
        <NavbarBig></NavbarBig>
      </v-container>
      <v-container v-else class="ma-0 pa-0" width="100%">
        <NavbarSmall></NavbarSmall>
      </v-container>
    </v-app-bar>
    <v-content>
      <v-container fluid :class="{'pa-0': $root.contentonly}" class="pa-0 ma-0">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
  <!-- Is Phone -->
  <v-app v-else style="background-color: #eee" class="ma-0 pa-0">
    <v-app-bar app v-if="!isLogin" class="ma-0 pa-0">
      <v-container class="ma-0 pa-0" width="100%">
        <NavbarSmall></NavbarSmall>
      </v-container>
    </v-app-bar>
    <v-content>
      <!--Removed pa-0 ma-0 from container below-->
      <v-container fluid :class="{'pa-0': $root.contentonly}" class="">
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import NavbarBig from "./components/navbar/navbarBig.vue";
import NavbarSmall from "./components/navbar/navbarSmall.vue";
export default {
  name: "App",
  components: {
    NavbarBig,
    NavbarSmall,
  },
  data() {
    return {
      scrolled: false,
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "authStatus"]),
    // Define if there should be NO navbar on it
    isLogin() {
      return this.$route.name ==='login' || this.$route.name ==='register' || this.$route.name ==='nextstep'
    }
  },
  mounted() {
    if (this.isLoggedIn && this.authStatus == "") {
      this.$store
        .dispatch("loginWithToken")
        .then(resp => {
          // setTimeout(() => this.$router.push("/"), 600);
        })
        .catch(err => {
          console.log(err);
        }
      );
    }
  },
  methods: {
    handleScroll () {
      this.scrolled = window.scrollY > 0;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>